module.exports = __webpack_public_path__ + "static/logos-lawyers-0af809600adb1788b8b2dab241f9f585.png";